import { useEffect, useState } from "react";
import { Footer } from "../components/footer";
import { Header } from "../components/header";
import { validateEmail } from "../utils";
import { toast } from "react-toastify";
import { handleAppError } from "../utils/error-handler";
import Loading from "../components/loading";
import { trackEvent, trackPageView } from "../utils/segment";

export function ContactUs() {
  const [contactFormInput, setContactFormInputs] = useState({
    name: "",
    email: "",
    phoneNumber: "",
    message: "",
  });
  const [loading, setLoading] = useState(false);
  const [messageSent, setMessageSent] = useState(false);

  useEffect(() => {
    trackPageView("Contact Page Viewed");
  }, []);

  const handleSendMessage = () => {
    // validate input values
    try {
      const isAllInputPresent =
        !!contactFormInput.message &&
        !!contactFormInput.name &&
        !!contactFormInput.phoneNumber;
      if (!isAllInputPresent)
        return toast.error("You need to fill all data before you can proceed");
      const isEmailValid = validateEmail(contactFormInput.email);
      if (!isEmailValid) return toast.error("Put a valid email and try again");
      setLoading(true);
      const body = {
        email: "media@mangrovefoods.com",
        subject: `${contactFormInput.name} sent you a message about Mangrove Foods! ✉`,
        text: `Hello There,
        You got a message from the Mangrove Foods website. The message is from ${contactFormInput.name}. You can reach ${contactFormInput.name} on 📞: ${contactFormInput.phoneNumber} or via email ✉: ${contactFormInput.email}: Their message reads:

${contactFormInput.message}
        `,
        data: null,
      };
      fetch(`${process.env.REACT_APP_EMAIL_URL}/send-mail`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      });
      toast.success("Email has been sent!");
      setMessageSent(true);
      trackEvent(`${contactFormInput.name} sent a message!`, {
        ...contactFormInput,
      });
    } catch (error) {
      handleAppError(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className='contact-us'>
      <Header />
      <div className='contact-us-container'>
        <div className='heading'>
          <h4>Get in Touch</h4>
          <p>
            Lorem ipsum dolor sit amet. Quo neque dolores ea optio odio quo
            quibusdam voluptate qui quibusdam quia. Id accusantium tempora 33
            natus amet eos totam atque sit incidunt nisi.
          </p>
        </div>
        <div className='content'>
          {messageSent ? (
            <div className='thank-you-message'>
              <i class='bi bi-envelope-check-fill'></i>
              <h3>Thank you for your message</h3>
              <p>
                {contactFormInput?.name || "John Doe"} , your message has been
                sent to the Mangrove Foods Team. Please expect a reply within
                24-48 hours. <br />
                You can you reach out also to us on the social media links
                below:
              </p>
              <div className='social-icons'>
                <a
                  href='http://facebook.com/mangrovefoods'
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  <i className='bi bi-facebook'></i>
                </a>
                <a
                  href='https://www.instagram.com/mangrove.foods/'
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  <i className='bi bi-instagram'></i>
                </a>
                <a
                  href={() => false}
                  // href='https://www.tiktok.com/mangrovefoods'
                  // target='_blank'
                  // rel='noopener noreferrer'
                >
                  <i className='bi bi-tiktok'></i>
                </a>
              </div>
            </div>
          ) : (
            <div className='row'>
              <div className='col-md-4 col-12'>
                <h4>Contact Information</h4>
                <p>
                  Lorem ipsum dolor sit amet. Quo neque dolores ea optio odio
                  quo quibusdam voluptate qui quibusdam quia.
                </p>
                <div className='social-icons'>
                  <a
                    href='http://facebook.com/mangrovefoods'
                    target='_blank'
                    rel='noopener noreferrer'
                  >
                    <i className='bi bi-facebook'></i>
                  </a>
                  <a
                    href='https://www.instagram.com/mangrove.foods/'
                    target='_blank'
                    rel='noopener noreferrer'
                  >
                    <i className='bi bi-instagram'></i>
                  </a>
                  <a
                    href={() => false}
                    // href='https://www.tiktok.com/mangrovefoods'
                    // target='_blank'
                    // rel='noopener noreferrer'
                  >
                    <i className='bi bi-tiktok'></i>
                  </a>
                </div>
              </div>
              <div className='col-md-8 col-12 form'>
                <section className='two-inputs'>
                  <div className=''>
                    <label>Name</label>
                    <input
                      className='form-control'
                      placeholder='Full Name'
                      value={contactFormInput?.name}
                      onChange={({ target: { value } }) =>
                        setContactFormInputs({
                          ...contactFormInput,
                          name: value,
                        })
                      }
                    />
                  </div>
                  <div className=''>
                    <label>Email</label>
                    <input
                      className='form-control'
                      placeholder='Email Address'
                      value={contactFormInput?.email}
                      onChange={({ target: { value } }) =>
                        setContactFormInputs({
                          ...contactFormInput,
                          email: value,
                        })
                      }
                    />
                  </div>
                </section>
                <div className=''>
                  <label>Phone Number</label>
                  <input
                    className='form-control'
                    placeholder='Phone Number'
                    value={contactFormInput?.phoneNumber}
                    onChange={({ target: { value } }) =>
                      setContactFormInputs({
                        ...contactFormInput,
                        phoneNumber: value,
                      })
                    }
                  />
                </div>
                <div className=''>
                  <label>Message/Comment</label>
                  <textarea
                    className='form-control'
                    cols={4}
                    placeholder='Enter your message...'
                    value={contactFormInput?.message}
                    onChange={({ target: { value } }) =>
                      setContactFormInputs({
                        ...contactFormInput,
                        message: value,
                      })
                    }
                  />
                </div>
                <button
                  className='button'
                  disabled={loading}
                  onClick={handleSendMessage}
                >
                  {loading ? <Loading /> : "Send Message"}
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
      <Footer />
    </div>
  );
}
